import type { CampaignStatus } from "@type/training";
import { cn } from "@util/tailwind";

// Campaign lifecycle status (draft / active / archived). Distinct vocabulary
// from session status (TrainingStatusPill), so it has its own badge styling.
// Shared across the dashboard Recent campaigns card and the Training Campaigns
// list so the colours stay in sync.
export function CampaignStatusBadge({
    status,
    className,
}: {
    status: CampaignStatus;
    className?: string;
}) {
    return (
        <span
            className={cn(
                "inline-flex flex-shrink-0 items-center px-2 py-0.5 rounded-full text-xs font-medium capitalize",
                status === "active"
                    ? "bg-green-100 text-green-800"
                    : status === "draft"
                      ? "bg-yellow-100 text-yellow-800"
                      : "bg-gray-100 text-gray-400",
                className
            )}
        >
            {status}
        </span>
    );
}
